var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007BB3",
    d: "m5.866 13.533-4.188 4.179a.983.983 0 0 1-1.39-1.39l4.179-4.188-4.18-4.179a4.25 4.25 0 0 1 4.12-1.084 1.7 1.7 0 0 0 1.627-.483L7.59 4.831a1.79 1.79 0 0 0 .424-1.714 2.22 2.22 0 0 1 .6-2.09l.729-.739a.993.993 0 0 1 1.4 0l6.968 6.968a.993.993 0 0 1 0 1.4l-.74.729a2.22 2.22 0 0 1-2.09.6 1.79 1.79 0 0 0-1.713.424l-1.557 1.557a1.7 1.7 0 0 0-.483 1.626 4.25 4.25 0 0 1-1.084 4.12z"
  })));
};
export default SvgPin;